import { SliderTitleStyle } from '@website-builder/widgets/slider/model/slider-title-style';

export class SliderSubtitleStyle extends SliderTitleStyle {
  alignment = '';

  static normalize(styles: Partial<SliderSubtitleStyle>): SliderSubtitleStyle {
    const sliderTitleStyle: SliderTitleStyle = SliderTitleStyle.normalize(styles);
    const pureStyles = new SliderSubtitleStyle();

    Object.assign(pureStyles, sliderTitleStyle);

    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;

    return pureStyles;
  }
}
